import { Icon, Button, IconTypeKey } from 'hfs-common-ui';
import { useTheme } from 'styled-components';
import { ReactNode } from 'react';
import { AlertVariant, getAlertIconColor } from 'core/utils';
import * as S from './styled';

export interface Props {
  variant: AlertVariant;
  ids?: {
    wrapper?: string;
    message?: string;
  };
  messageText: string;
  iconType: IconTypeKey;
  children?: ReactNode;
  dismissText?: string;
  dismissClickHandler?(): void;
}

const AlertBanner = ({
  variant,
  ids,
  messageText,
  iconType,
  dismissText,
  children,
  dismissClickHandler,
}: Props) => {
  const theme = useTheme();
  return (
    <S.AlertWrapperDiv id={ids?.wrapper}>
      <S.BannerDiv $variant={variant}>
        <S.BannerContentDiv>
          <S.MessageWrapperDiv>
            <S.IconWrapperDiv>
              <Icon type={iconType} color={getAlertIconColor(theme, variant)} />
            </S.IconWrapperDiv>
            <S.MessageDiv id={ids?.message}>{messageText}</S.MessageDiv>
          </S.MessageWrapperDiv>
          {children && <S.ChildrenContainerDiv>{children}</S.ChildrenContainerDiv>}
        </S.BannerContentDiv>
        {dismissClickHandler && dismissText && (
          <S.ActionButtonDiv>
            <Button variant="surface" size="small" onClick={dismissClickHandler}>
              {dismissText}
            </Button>
          </S.ActionButtonDiv>
        )}
      </S.BannerDiv>
    </S.AlertWrapperDiv>
  );
};

export default AlertBanner;
